import $ from 'jquery';
import * as jqueryModal from 'jquery-modal';
import querystring from 'querystring';
import {
  AppManager,
  SoundManager,
  modalDir,
  appConfig,
  logger,
  AnalyticsManager,
  ViewHistoryManager,
} from '@common';
import * as embeddedVideo from '~/../src_modals/scripts/embeddedVideo';
import * as embeddedVideoOnPopup from '~/../src_modals/scripts/embeddedVideoOnPopup';
import * as embeddedImage from '~/../src_modals/scripts/embeddedImage';
import * as embeddedHelp from '~/../src_modals/scripts/embeddedHelp';
// import * as embeddedVideoInfo from '~/../src_modals/scripts/embeddedVideoInfo';

const addRandom = true;
const commonModalSettings = {
  closeExisting: false,
  escapeClose: false,
  clickClose: false,
  closeClass: 'initial-hidden',
  blockerClass: 'blocker-blur',
};

class PopupManager {
  constructor() {
    this.panoramaControllers = {};
    this.productInfoList = [];
    this.productViewConfigs = {};
  }


  cancelLoadingVideo(videoModal) {
    // embeddedVideoでの動画ロード中にモーダルを閉じた時にロードをキャンセルする
    // https://stackoverflow.com/questions/4071872/html5-video-force-abort-of-buffering
    const videoElement = $('video', videoModal);
    const video = videoElement.get(0);
    if (!video) return;
    const wasPlaying = !video.paused;
    video.currentTime = 0.0; // Optional -- can be left out for pause
    video.pause();
    video.src = '';
    video.preload = 'none';
    video.autoplay = false;
    if (wasPlaying) { // This prevents the browser from trying to load the entire source
      video.load();
    }
  }


  openHelp(closeCallback = null) {
    const context = {
      language: AppManager.currentLanguage,
      popupManager: this,
    };
    const helpImages = this.getHelpImages();
    const modal = $('#modal-1').html(embeddedHelp.tag);
    embeddedHelp.init(modal, context, helpImages);

    $('#modal-1').modal({
      ...commonModalSettings,
      closeClass: `center-close center-close--${AppManager.currentLanguage}`,
      modalClass: 'modal modal--embed modal--help',
      blockerClass: 'blocker-clear',
    });

    $('#modal-1').one($.modal.BEFORE_CLOSE, (event, modal) => {
      event.preventDefault();
    });

    $('#modal-1').one($.modal.AFTER_CLOSE, (event, modal) => {
      event.preventDefault();
      $(event.currentTarget).empty();
      $(event.currentTarget).removeClass();
      if (closeCallback) closeCallback();
    });
  }

  openIntroContent(intro, closeCallback = null, completeCallback = null) {
    const context = {
        language: AppManager.currentLanguage,
        popupManager: this,
    };
    switch (intro.type) {
        case "modal--video" :
            this.openVideo(intro, closeCallback, completeCallback);
            break;
    }
  }

  openImage(imagePath, link = null, closeCallback = null) {
    const context = {
      language: AppManager.currentLanguage,
      popupManager: this,
    };
    const modal = $('#modal-1').html(embeddedImage.tag); 
    embeddedImage.init(modal, context, imagePath, link);

    $('#modal-1').modal({
      ...commonModalSettings,
      closeClass: `center-close center-close--${AppManager.currentLanguage}`,
      modalClass: 'modal modal--embed modal--image',
    });

    $('#modal-1').one($.modal.BEFORE_CLOSE, (event, modal) => {
      event.preventDefault();
    });

    $('#modal-1').one($.modal.AFTER_CLOSE, (event, modal) => {
      event.preventDefault();
      $(event.currentTarget).empty();
      $(event.currentTarget).removeClass();
      if (closeCallback) closeCallback();
    });
  }


  reopenImage(popupTo) {
    const popupConf = AppManager.getPopupConf(popupTo);
    if (!popupConf) return;
    $.modal.close();
    if (popupConf.action.type.indexOf('modal--image') >= 0) {
      const imagePath = this.getLocalizedContent(popupConf.action);
      this.openImage(imagePath, popupConf.action.link);
    }
  }


  async openVideo(options, closeCallback = null, completeCallback = null) {
    const context = {
      language: AppManager.currentLanguage,
      popupManager: this,
    };
    if (!options.hasOwnProperty('content') || !options.hasOwnProperty('type') || options.type.indexOf('modal--video') === -1) return;

    const productNotice = this.getProductNotice();
    let videoModal;
    let divModal;
    switch (options.type) {
      case 'modal--video':
        divModal = $('#modal-1');
        videoModal = divModal.html(embeddedVideo.tag);
        context.videoId = this.getLocalizedContent(options);
        if (options.products) {
          const productData = await this.loadProductData(options.products).catch(error => {
            logger.error(error);
          });
          if (!productData) return;
          this.productInfoList = productData;
          context.productIds = options.products;
        }
        embeddedVideo.init(videoModal, context, productNotice, completeCallback);
        if (!options.bgm) SoundManager.muteBGM();
        break;
      case 'modal--video--on--popup':
        divModal = $('#modal-4');
        videoModal = divModal.html(embeddedVideoOnPopup.tag);
        context.videoId = this.getLocalizedContent(options);
        embeddedVideoOnPopup.init(videoModal, context, productNotice, completeCallback); 
        if (!options.bgm) SoundManager.muteBGM();
        break;
      // case 'modal--video_info':
      //   videoModal = $('#modal-1').html(embeddedVideoInfo.tag);
      //   context.videoId = this.getLocalizedContent(options);
      //   context.infoId = options.infoId;
      //   embeddedVideoInfo.init(videoModal, context);
      //   if (!options.bgm) SoundManager.muteBGM();
      //   break;
    }
    
    AppManager.toggleFloorNav(false);
    divModal.modal({
      ...commonModalSettings,
      closeClass: options.type === 'modal--video--on--popup' ? 'visible-close' : '',
      modalClass: 'modal modal--embed ' + options.type + (productNotice ? ' has-notice' : ''),
    });

    divModal.one($.modal.BEFORE_CLOSE, (event, modal) => {
      event.preventDefault();
      this.cancelLoadingVideo(videoModal);
    });

    divModal.one($.modal.AFTER_CLOSE, (event, modal) => {
      event.preventDefault();
      $(event.currentTarget).empty();
      $(event.currentTarget).removeClass();
      AppManager.toggleFloorNav(true);
      SoundManager.replayBGM();
      if (closeCallback) closeCallback();
    });
    ViewHistoryManager.saveVideo(context.videoId);
  }


  async openIframe(options, closeCallback = null) {
    $('#modal-1').html('<iframe id="modal-1-iframe" frameborder="no"></iframe>');
    let target;
    if (!options.hasOwnProperty('content')) return;
    let params = {
      lang: AppManager.currentLanguage,
      ifid: 'modal-1-iframe',
    };
    if (options.hasOwnProperty('type')) {
      switch (options.type) {
        /*
        // #deprecated : 動画はiframeを使わない
        case 'modal--video':
          params.vid = encodeURIComponent(options.content);
          if (options.products) {
            const productData = await this.loadProductData(options.products).catch(error => {
              logger.error(error);
            });
            if (!productData) return;
            this.productInfoList = productData;
            params.pids = options.products.join(appConfig.pidSeparator);
          }
          target = `${modalDir}/video.html`;
          SoundManager.muteBGM();
          break;
        case 'modal--video_info':
          params.vid = options.content;
          target = `${modalDir}/video_info.html`;
          SoundManager.muteBGM();
          break;
        */
        // case 'modal--products':
        //   params.view = options.content;
        //   target = `${modalDir}/products.html`;
        //   break;
      }
    }
    if (!target) return;

    if (addRandom) {
      params.r = new Date().valueOf();
    }
    const qs = querystring.stringify(params);
    $('#modal-1-iframe').attr({
      src: target + (qs.length > 0 ? `?${qs}` : ''),
      width: '100%',
      height: '100%'
    });

    AppManager.toggleFloorNav(false);
    $('#modal-1').modal({
      ...commonModalSettings,
      modalClass: 'modal ' + options.type,
    });

    $('#modal-1').one($.modal.AFTER_CLOSE, (event, modal) => {
      $('#modal-1-iframe').remove();
      $('#modal-1').removeClass();
      AppManager.toggleFloorNav(true);
      SoundManager.replayBGM();
      if (closeCallback) closeCallback();
    });
  }


  loadProductData(productIds) {
    return new Promise((resolve, reject) => {
      const requests = productIds.map(pidColored => {
        const pid = pidColored.split('--')[0];
        return $.getJSON(`${appConfig.productDataPath}/products_${pid}.json`);
      });
      if (requests.length > 1) {
        $.when(...requests)
          .then((...results) => {
            resolve(results.map(res => res[0]));
          })
          .fail((...results) => {
            console.error('product data load error', results);
            reject(results);
          });
      } else if (requests.length === 1) {
        requests[0]
          .done((data) => {
            resolve([data]);
          })
          .fail((jqXHR, textStatus, errorThrown) => {
            reject(errorThrown);
          });
      } else {
        reject('no request found');
      }
    });
  }


  // 横スクロール商品盤面
  async openProductDetailView(viewType, detailId) {
    /*
    // 一次元配列化して重複を削除
    const products = this.getProductViewConfigByType(viewType).detailViews
      .map(entry => entry.products)
      .flat()
      .filter((x, i, self) => {
        return self.indexOf(x) === i;
      });
    const productData = await this.loadProductData(products).catch(error => {
      logger.error(error);
    });
    if (!productData) return;
    this.productInfoList = productData;

    const target = `${modalDir}/products_detail.html`;
    const params = {
      view: viewType,
      did: detailId,
      lang: AppManager.currentLanguage,
      ifid: 'modal-2-iframe',
    };
    if (addRandom) {
      params.r = new Date().valueOf();
    }
    const qs = querystring.stringify(params);
    const iframe = $('#modal-2').html('<iframe id="modal-2-iframe" frameborder="no"></iframe>');
    $('#modal-2-iframe').attr({
      src: target + (qs.length > 0 ? `?${qs}` : ''),
      width: '100%',
      height: '100%'
    });
    iframe.modal({
      ...commonModalSettings,
      modalClass: 'modal modal--products'
    });
    */
  }


  // DIGISKIN TESTER、MAKE ME UP 商品詳細
  openProductInfo(productId, viewType, reload = false) {
    /*
    const isDigiskin = viewType === 'digiskin_tester';
    const target = isDigiskin ? `${modalDir}/product_info_dgt.html` :
      `${modalDir}/product_info.html`;
    const params = {
      view: viewType,
      pid: productId,
      lang: AppManager.currentLanguage,
      ifid: 'modal-3-iframe',
    };
    if (addRandom) {
      params.r = new Date().valueOf();
    }
    const qs = querystring.stringify(params);
    const iframe = reload ? $('#modal-3') : $('#modal-3').html('<iframe id="modal-3-iframe" frameborder="no"></iframe>');
    $('#modal-3-iframe').attr({
      src: target + (qs.length > 0 ? `?${qs}` : ''),
      width: '100%',
      height: '100%'
    });
    if (!reload) {
      iframe.modal({
        ...commonModalSettings,
        modalClass: isDigiskin ? 'modal modal--product-info modal--product-info-dgt' :
        'modal modal--product-info'
      });
    }
    AnalyticsManager.sendProduct(productId, isDigiskin ? 'digiskin' : 'makemeup');
    */
  }


  notifyClosePosition(positions, calledFrom) {
    const parentModal = $(calledFrom).parent();
    const close = parentModal.length > 0 ? $('a.close-modal', parentModal) : $('.blocker.current .modal a.close-modal');
    if (positions && Object.keys(positions).length > 0) {
      const buttonOffsets = {
        top: -12.5,
        right: -12.5,
      };
      Object.keys(positions).forEach(key => {
        if (buttonOffsets[key] !== undefined) positions[key] += buttonOffsets[key];
      });
      close.css(positions);
    }
    close.removeClass('initial-hidden');
  }


  getProductInfoById(productId) {
    return this.productInfoList.find(info => info.jan_code === productId);
  }


  // 別規格（別サイズ・別カラー）商品情報追加読み込み
  async addProductInfoById(productId) {
    let info = null;
    info = this.productInfoList.find(info => info.jan_code === productId);
    if (info) return info;
    // 追加でJSON取得
    const productData = await this.loadProductData([productId]).catch(error => {
      logger.error(error);
    });
    if (!productData) return null;
    this.productInfoList = this.productInfoList.concat(productData);
    info = this.productInfoList.find(info => info.jan_code === productId);
    return info;
  }


  registerProductViewConfig(type, config) {
    if (this.registerProductViewConfig[type]) return;
    this.registerProductViewConfig[type] = config;
  }


  getProductViewConfigByType(type) {
    return this.registerProductViewConfig[type];
  }


  isModalVisible() {
    return $('[id^="modal-"]:visible').length > 0;
  }


  getLocalizedContent(action) {
    if (action['content_' + AppManager.currentLanguage]) {
      return action['content_' + AppManager.currentLanguage];
    }
    return action.content;
  }


  getHelpImages() {
    const data = AppManager.metaConfig.helpImages;
    if (data && data[AppManager.currentLanguage] && data['files']) {
      return {
        dir: data[AppManager.currentLanguage],
        files: data['files']
      };
    }
    return null;
  }


  getProductNotice() {
    const data = AppManager.metaConfig.productNotice;
    if (data && data[AppManager.currentLanguage] && data[AppManager.currentLanguage].length > 0) {
      return data[AppManager.currentLanguage];
    }
    return null;
  }


  getVideoInfoById(infoId) {
    const data = AppManager.metaConfig.videoInfo;
    if (data && data[infoId]) {
      if (data[infoId][AppManager.currentLanguage]) {
        return data[infoId][AppManager.currentLanguage];
      } else if (data[infoId]['en']) {
        return data[infoId]['en'];
      }
    }
    return null;
  }


  getViewHistoryParams() {
    return ViewHistoryManager.buildParams();
  }


  getProductStock(productId) {
    // APIから在庫数取得（不使用）
    return null;
  }


  notifyClickBooking() {
    AnalyticsManager.sendBooking();
  }
}

// expose for child frame
window.PopupManager = new PopupManager();

// export default new PopupManager();
export default window.PopupManager;